import React from 'react';
import Accordion from 'components/Accordion';
import { Contract, IProps, ReviewTermsFormValue, IState } from './types';
import _ from 'lodash';
import { Link } from 'bff/models/link';
import commonService from 'utils/commonService';
import sweetAlertService from 'utils/sweetAlertService';
// import PDFViewer from 'components/PDFViewer';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { Field, FieldArray, Form, Formik } from 'formik';
import service from 'bff/services/signupService';
import { CodeId } from 'constants/enums/codeId.enum';
import apiCommonService from 'bff/services/commonService';
import PDFAllPageViewer from 'components/PDFAllPageViewer';

const formInitVal: ReviewTermsFormValue = {
  CONTRACTS: new Array(0),
  ALL_CONTRACT_CHECKED: false,
  AGGREE_RECEIVE_PRODUCT_INFO: true
};

let formInitialValues = formInitVal;

class ReviewTerms extends React.Component<IProps, IState> {
  private formikRef = React.createRef() as any;

  state: IState = {
    regdocLinks: new Array(0),
    termStatus: new Array(0)
  }

  componentDidMount = async () => {
    const regdocLinks = await service.fetchRegdocLinks(this.props.applicationId);

    if (regdocLinks) {
      const contracts = this.handleGetContracts(regdocLinks);

      const serverTimeMs = await apiCommonService.fetchSysTime(this.props.applicationId);

      formInitialValues = {
        ...formInitialValues,
        CONTRACTS: contracts,
        AGGREE_RECEIVE_PRODUCT_INFO_TIME: serverTimeMs
      };

      this.setState({
        regdocLinks: [...regdocLinks],
        termStatus: commonService.getInitTermStatus(contracts)
      });
    }
  }

  /**
     * @description 取得要保人聲明事項初始值
    */
  handleGetContracts = (contractLinks: Link[]) => {
    const res = new Array(0);
    if (contractLinks && contractLinks.length > 0) {
      _.forEach(contractLinks, (contractLink: Link, index: number) => {
        res.push({
          LINK_NAME: contractLink.NAME,
          LINK_URL: contractLink.URL,
          CONTRACT: false
        });
      });
    }
    return res;
  };

  /**
   * @description 根據路徑下載檔案
  */
  handleDownloadFile = (event: React.MouseEvent<HTMLButtonElement>, linkUrl: string, fileName: string) => {
    event.stopPropagation();
    try {
      commonService.downloadFile(linkUrl, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  };

  /**
   * @description 更新系統時間
   */
  handleCheckboxClick = async (checked: boolean, fieldName: string, setFieldValue: any, isChild?: boolean) => {
    if (checked) {
      const serverTimeMs = await apiCommonService.fetchSysTime(this.props.applicationId);

      setFieldValue(fieldName, serverTimeMs);
    }

    if (!checked) {
      setFieldValue(fieldName, null);

      if (isChild) {
        setFieldValue('ALL_CONTRACT_CHECKED', false);
        setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
      }
    }
  }

  render () {
    return (
      <div className="review-terms">
        <Formik
          initialValues={formInitialValues}
          enableReinitialize
          innerRef={this.formikRef}
          onSubmit={(values: ReviewTermsFormValue) => this.props.onNextStep(values)}
        >
          {
            ({ values, setFieldValue }) => (
              <Form>
                <div className="review-terms__desc">
                  <p>請審閱並勾選以下條款，並點選「我已審閱並同意」進行下一步。</p>
                </div>
                <div className="review-terms__content">
                  <FieldArray name="CONTRACTS">
                    {
                      () => (
                        <>
                          <Accordion>
                            {
                              this.state.regdocLinks.length > 0 && _.map(this.state.regdocLinks, (regdocLink: Link, index: number) => {
                                return (
                                  <Accordion.Item
                                    key={index}
                                    updateStatus={(openVal: any) => {
                                      // 更新條款狀態
                                      this.setState({
                                        termStatus: commonService.headerClickUpdateTermStatus(openVal, index, this.state.termStatus)
                                      });
                                    }}
                                    isActive={commonService.setPDFOpen(index, this.state.termStatus)}
                                  >
                                    <Accordion.Header title={regdocLink.NAME}>
                                      <button type="button" className="review-terms__download-btn" onClick={(event: React.MouseEvent<HTMLButtonElement>) => this.handleDownloadFile(event, regdocLink.URL, regdocLink.NAME)} />
                                    </Accordion.Header>
                                    <Accordion.Content>
                                      <PDFAllPageViewer
                                        url={regdocLink.URL}
                                        show={commonService.setPDFOpen(index, this.state.termStatus) || false}
                                        updateStatus={(bottom: any) => {
                                          // 更新條款狀態
                                          this.setState((prev: any) => ({
                                            ...prev,
                                            termStatus: commonService.headerScrollUpdateTermStatus(bottom, index, this.state.termStatus)
                                          }));
                                        }}
                                        checkContracts={() => {
                                          setFieldValue(`CONTRACTS[${index}].CONTRACT`, true);
                                        }}
                                      />
                                    </Accordion.Content>
                                    <Accordion.Addition>
                                      <div className="element__checkbox-group">
                                        <label htmlFor={`checkbox${index}`}>
                                          <div className="element__checkbox">
                                            <Field
                                              disabled={commonService.setPDFCheckable(index, this.state.termStatus)}
                                              type="checkbox"
                                              name={`CONTRACTS[${index}].CONTRACT`}
                                              id={`checkbox${index}`}
                                              onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                this.handleCheckboxClick(e.currentTarget.checked, `CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, setFieldValue, true);

                                                // 更新條款狀態
                                                this.setState({
                                                  termStatus: commonService.updateTermStatus(e.currentTarget.checked, index, this.state.termStatus)
                                                });
                                              }}
                                            />
                                            <div className="element__checkbox-btn" />
                                          </div>
                                          <span>審閱條款</span>
                                        </label>
                                      </div>
                                    </Accordion.Addition>
                                  </Accordion.Item>
                                );
                              })
                            }
                          </Accordion>
                        </>
                      )
                    }
                  </FieldArray>
                </div>
                <div className="review-terms__all-check">
                  <div className="element__checkbox-group">
                    <label htmlFor="all-checked-checkbox">
                      <div className="element__checkbox">
                        <Field
                          type="checkbox"
                          name="ALL_CONTRACT_CHECKED"
                          id="all-checked-checkbox"
                          disabled={_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT)}
                          onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                            this.handleCheckboxClick(e.currentTarget.checked, 'ALL_CONTRACT_CHECKED_TIME', setFieldValue);

                            if (e.currentTarget.checked) {
                              // 重置已展開的條款
                              this.setState({
                                termStatus: commonService.resetTermStatus(this.state.termStatus)
                              });
                            }
                          }}
                        />
                        <div className="element__checkbox-btn" />
                      </div>
                      <span className={'agree-all-terms' + (_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT) ? ' grey' : '')}>我已審閱及同意上述條款</span>
                    </label>
                  </div>
                </div>
                <div className="review-terms__agree-receive-prod-info">
                  <div className="element__checkbox-group">
                    <label htmlFor="agree-receive-prod-info-checkbox">
                      <div className="element__checkbox">
                        <Field
                          type="checkbox"
                          name="AGGREE_RECEIVE_PRODUCT_INFO"
                          id="agree-receive-prod-info-checkbox"
                          onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                            this.handleCheckboxClick(e.currentTarget.checked, 'AGGREE_RECEIVE_PRODUCT_INFO_TIME', setFieldValue);
                          }}
                        />
                        <div className="element__checkbox-btn" />
                      </div>
                      <span>{commonService.getCodeMsg(this.props.UICode, CodeId.U016)}</span>
                    </label>
                  </div>
                </div>
                <div className="review-terms__controls">
                  <button type="button" className="element__button element__button--red-border" onClick={this.props.onGoBack}>
                    返回上一頁，取消註冊
                  </button>
                  <button
                    type="submit"
                    className="element__button element__button--red"
                    disabled={_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT) || !values.ALL_CONTRACT_CHECKED}
                  >
                    下一步
                  </button>
                </div>
              </Form>
            )
          }
        </Formik>
      </div>
    );
  }
};

export default ReviewTerms;
